import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status"]
  static values = { delay: { type: Number, default: 2000 } }

  connect() {
    this.armed = false
    this.submitting = false
    this.debounceTimer = null
    this.abortController = null
    this.statusTimer = null

    // Arm after 500ms to skip initial Lexxy load events
    this.armTimer = setTimeout(() => { this.armed = true }, 500)

    this.handleManualSubmit = this.cancelForManualSubmit.bind(this)
    this.element.addEventListener("turbo:submit-start", this.handleManualSubmit)
  }

  disconnect() {
    clearTimeout(this.armTimer)
    clearTimeout(this.debounceTimer)
    clearTimeout(this.statusTimer)
    this.abortController?.abort()
    this.element.removeEventListener("turbo:submit-start", this.handleManualSubmit)
  }

  change() {
    if (!this.armed || this.submitting) return
    this.scheduleSave()
  }

  scheduleSave() {
    clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => this.save(), this.delayValue)
  }

  async save() {
    this.abortController?.abort()
    this.abortController = new AbortController()

    this.setStatus("Saving...")

    const formData = new FormData(this.element)

    try {
      const response = await fetch(this.element.action, {
        method: "PATCH",
        headers: {
          "X-Autosave": "true",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: formData,
        signal: this.abortController.signal
      })

      if (response.ok) {
        this.setStatus("Saved", 3000)
      } else {
        const data = await response.json()
        this.setStatus(data.errors?.[0] || "Error saving")
      }
    } catch (error) {
      if (error.name !== "AbortError") {
        this.setStatus("Error saving")
      }
    }
  }

  cancelForManualSubmit() {
    this.submitting = true
    clearTimeout(this.debounceTimer)
    this.abortController?.abort()
  }

  setStatus(text, clearAfter = null) {
    if (!this.hasStatusTarget) return

    clearTimeout(this.statusTimer)
    this.statusTarget.textContent = text

    if (clearAfter) {
      this.statusTimer = setTimeout(() => {
        this.statusTarget.textContent = ""
      }, clearAfter)
    }
  }
}
